module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "box-body",
    staticStyle: {
      "max-height": "500px",
      "overflow": "auto"
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo m-t-20",
    attrs: {
      "drag": "",
      "action": "reports/v1/upload/",
      "auto-upload": false,
      "http-request": _vm.upload,
      "on-preview": _vm.handlePreview,
      "on-remove": _vm.handleRemove,
      "file-list": _vm.fileList,
      "limit": 1
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("Drop file here or "), _c('em', [_vm._v("click to upload")])])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer text-right p-t-15 p-b-15",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelUploadAction
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.submitUpload
    }
  }, [_vm._v("Upload Report")])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', {
    staticClass: "p-b-12"
  }, [_vm._v("Updated Report")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.tableLoading),
      expression: "tableLoading"
    }]
  }, [(_vm.publisherDomainList.length != 0) ? _c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_vm._l((_vm.publisherDomainList), function(data) {
    return _c('el-collapse-item', {
      staticClass: "collapse--item",
      attrs: {
        "title": data.publisher,
        "name": data.publisher
      }
    }, _vm._l((data.domains), function(i, index) {
      return _c('div', [_c('el-collapse', {
        attrs: {
          "accordion": ""
        }
      }, [_c('el-collapse-item', {
        staticClass: "collapse--item"
      }, [_c('template', {
        slot: "title"
      }, [_c('div', {
        staticStyle: {
          "width": "100%"
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tReport for " + _vm._s(i) + "\n\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('el-table', {
        directives: [{
          name: "loading",
          rawName: "v-loading",
          value: (_vm.loading),
          expression: "loading"
        }],
        staticStyle: {
          "width": "100%",
          "border-spacing": "0"
        },
        attrs: {
          "data": _vm.getFilteredReport(_vm.reportData, i),
          "id": "",
          "height": "450"
        }
      }, [_c('el-table-column', {
        staticClass: "text-center",
        attrs: {
          "label": "Report Date"
        },
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(props) {
            return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getFormattedDate(props.row.date)) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")]
          }
        }], null, true)
      }), _vm._v(" "), _c('el-table-column', {
        staticClass: "text-center",
        attrs: {
          "label": "Site",
          "prop": "site"
        }
      }), _vm._v(" "), _c('el-table-column', {
        staticClass: "text-center",
        attrs: {
          "label": "Dimension",
          "prop": "dimension"
        }
      }), _vm._v(" "), _c('el-table-column', {
        staticClass: "text-center",
        attrs: {
          "label": "Bidder",
          "prop": "bidder"
        }
      }), _vm._v(" "), _c('el-table-column', {
        staticClass: "text-center",
        attrs: {
          "label": "Bidder Impression",
          "prop": "bidder_impression"
        }
      }), _vm._v(" "), _c('el-table-column', {
        staticClass: "text-center",
        attrs: {
          "label": "Bidder Revenue",
          "prop": "bidder_revenue"
        }
      }), _vm._v(" "), _c('el-table-column', {
        staticClass: "text-center",
        attrs: {
          "label": "DFP Impression",
          "prop": "dfp_impression"
        }
      }), _vm._v(" "), _c('el-table-column', {
        staticClass: "text-center",
        attrs: {
          "label": "DFP Revenue",
          "prop": "dfp_revenue"
        }
      }), _vm._v(" "), _c('el-table-column', {
        staticClass: "text-center",
        attrs: {
          "label": "Bidder eCPM"
        },
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(props) {
            return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(props.row.dfp_currency + ". " + _vm.getRoundedNumbers((props.row.bidder_revenue / props.row.bidder_impression) * 1000)) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")]
          }
        }], null, true)
      }), _vm._v(" "), _c('el-table-column', {
        staticClass: "text-center",
        attrs: {
          "label": "DFP eCPM"
        },
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(props) {
            return [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(props.row.dfp_currency + ". " + _vm.getRoundedNumbers((props.row.dfp_revenue / props.row.dfp_impression) * 1000)) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")]
          }
        }], null, true)
      })], 1), _vm._v(" "), _c('div', {
        staticClass: "container"
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-md-4 col-sm-6 col-xs-12"
      }, [_c('h5', [_vm._v("DFP Total:")]), _vm._v(" "), _c('p', [_vm._v("Total Revenue: " + _vm._s(_vm.getRevenueTotal(_vm.getFilteredReport(_vm.reportData, i), 'dfp_revenue')))]), _vm._v(" "), _c('p', [_vm._v("Total Impressions: " + _vm._s(_vm.getValTotal(_vm.getFilteredReport(_vm.reportData, i), 'dfp_impression')))])]), _vm._v(" "), _c('div', {
        staticClass: "col-md-4 col-sm-6 col-xs-12"
      }, [_c('h5', [_vm._v("Bidder Total:")]), _vm._v(" "), _c('p', [_vm._v("Total Revenue: " + _vm._s(_vm.getRevenueTotal(_vm.getFilteredReport(_vm.reportData, i), 'bidder_revenue')))]), _vm._v(" "), _c('p', [_vm._v("Total Impressions: " + _vm._s(_vm.getValTotal(_vm.getFilteredReport(_vm.reportData, i), 'bidder_impression')))]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
        staticClass: "col-md-4 col-sm-6 col-xs-12"
      }, [_c('div', [_c('h5', [_vm._v("exchange rate for usd to inr: ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getExchangeRate(_vm.currencyArr, i)))])]), _vm._v(" "), _c('div', [_c('el-button', {
        attrs: {
          "type": "success",
          "icon": _vm.approveBtn
        },
        on: {
          "click": function($event) {
            return _vm.approveData(i, _vm.report_date, $event)
          }
        }
      }, [_vm._v("Approve Report")])], 1)])])])], 2)], 1)], 1)
    }), 0)
  }), _vm._v(" "), _c('div', {
    staticClass: "text-right p-t-15 p-b-15"
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "icon": _vm.approveBtn
    },
    on: {
      "click": function($event) {
        return _vm.approveAllData(_vm.report_date, $event)
      }
    }
  }, [_vm._v("Approve Complete Report")])], 1)], 2) : _c('div', [_vm._v("No data available")])], 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border heading-cart"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Publisher Reports Approval")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-51aa382a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/reports/ReportsAdminApproval.vue
// module id = 690
// module chunks = 2